import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface EmptyResultsProps {
    title: string;
    description?: string;
    action?: ReactNode;
    dataTestClass?: string;
}

export const EmptyResults = ({
    title,
    description,
    action,
    dataTestClass,
}: EmptyResultsProps) => {
    const hasDescription = Boolean(description);
    const titleMarginBottom = hasDescription ? '16px' : action ? '40px' : 0;

    return (
        <Box
            data-testclass={dataTestClass}
            sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                padding: '24px',
            }}
        >
            <Typography
                variant={hasDescription ? undefined : 'body1'}
                sx={{
                    ...(hasDescription
                        ? {
                              fontWeight: 600,
                              fontSize: '2rem',
                              lineHeight: 'normal',
                          }
                        : {}),
                    textAlign: 'center',
                    color: 'common.black',
                    marginBottom: titleMarginBottom,
                }}
            >
                {title}
            </Typography>
            {description ? (
                <Typography
                    variant="body1"
                    sx={{
                        lineHeight: 'normal',
                        textAlign: 'center',
                        color: 'common.black',
                        maxWidth: '600px',
                        marginBottom: action ? '40px' : 0,
                    }}
                >
                    {description}
                </Typography>
            ) : null}
            {action}
        </Box>
    );
};
